export enum FFMPEGLOGTypes {
  ERROR = 'fferr',
  INFO = 'info',
}

export type FFmpegLog = { type: string; message: string };
